import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const GlobeIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M10 1.66602C12.0844 3.94798 13.269 6.90938 13.3334 9.99935C13.269 13.0893 12.0844 16.0507 10 18.3327M10 1.66602C7.91562 3.94798 6.73106 6.90938 6.66669 9.99935C6.73106 13.0893 7.91562 16.0507 10 18.3327M10 1.66602C5.39765 1.66602 1.66669 5.39698 1.66669 9.99935C1.66669 14.6017 5.39765 18.3327 10 18.3327M10 1.66602C14.6024 1.66602 18.3334 5.39698 18.3334 9.99935C18.3334 14.6017 14.6024 18.3327 10 18.3327M2.08337 7.49935H17.9167M2.08335 12.4993H17.9167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
